import React from 'react';
import './Contact.css';
import './About.css';
import './App.css';
import Footer from '../store/Components/Footer';
import Query from './parts/accordianContact';
import "./About.css";
import { useState } from 'react';
import { publicRequest } from '../store/requestMethods';
import { Home, LocalPostOffice, Contacts } from "@material-ui/icons";
import {
	Facebook,
	LinkedIn,
} from "@material-ui/icons";
import {
	Link
} from "react-router-dom";
import { useEffect } from 'react';
export default function Contact() {
	const [inputs, setInputs] = useState({ name: "", suggestion: "", email: "", phone: ""});
	const handleChange = (e) => {
		setInputs(prev => {
			return { ...prev, [e.target.name]: e.target.value };
		});
		console.log(inputs);
	};
	useEffect(()=>{
		window.scrollTo(0, 0);
	},[])
	const handleClick = async (e) => {
		e.preventDefault();
		await publicRequest.post("/suggestion", inputs);
		setInputs({ name: "", suggestion: "" });
	}
	return (
		<div>
			<img src="./images/voolvo.jpg" alt="asgfsdg" height="600px" width="400px" className="sahi" />
			<div className='contactTopUscont'>
				<h1 className="">MechOnTrack</h1>
				<p className="">Be in touch with us.</p>
			</div>

			<div className='mechOnFindUs'>
				<h3 className="mechOnFindUs_heading">FIND US AT</h3>
				<div className='mechOnFindUsIn'>
					<div>
						<Home />
						<p>31, MechOnTrack Inc. Dewas, Madhya Pradesh, India 455001</p>
					</div>
					<div>
						<LocalPostOffice />
						<p>You can reach us at MechOnTrack@gmail.com with all queries.</p>
					</div>
					<div>
						<Contacts />
						<p>You can reach us at MechOnTrack@gmail.com with all queries.</p>
					</div>
				</div>
			</div>

			<div className='maptagBack'>
				<div className="maptag">
					<iframe className="map"
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7348.45995188886!2d76.04768512287406!3d22.94175602020509!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396318250ac87eef%3A0xeb76cb769061a847!2sBalgarh%2C%20Balaji%20Nagar%2C%20Dewas%2C%20Madhya%20Pradesh%20455111!5e0!3m2!1sen!2sin!4v1633415760193!5m2!1sen!2sin"
						allowFullScreen loading="lazy"></iframe>
				</div>
			</div>
			
			<div className='contact_us'>
				<img src='./images/form_back.jpg' alt=''></img>
				<div><h2 className="love">WE LOVE TO HEAR YOU</h2></div>
				<div className='contact_align'>
					<div className='contactFormDetails'>
						<h3>Quality support, just a message away</h3>
						<div>
							<p>Find Us Here</p>
							<a href="mailto:chetan.songara140395@gmail.com">chetan.songara140395@gmail.com</a>
							<p className='socIco'><Link href='#' className='fb'><Facebook /></Link>
								<Link href='/about' className='ln'><LinkedIn /></Link></p>
						</div>
					</div>
					<div className='contactForm'>
						<form>
							<input type='text' placeholder="Enter Your Name" name='name' value={inputs.name} onChange={handleChange} />
							<input type='text' placeholder="Enter Your Email" name='email' value={inputs.email} onChange={handleChange} />
							<input type='text' placeholder="Enter Your Phone" name='phone' value={inputs.phone} onChange={handleChange} />
							{/* <input type='text' placeholder="" className="message" name="suggestion" value={inputs.suggestion} onChange={handleChange} /> */}
							<textarea name="suggestion" placeholder="Enter Your Message" value={inputs.suggestion} onChange={handleChange} className="message">
							</textarea>
							<button onClick={handleClick}>SEND MESSAGE</button>
						</form>
					</div>
				</div>
			</div>
			<Query />
			<Footer />

		</div>

	)

}


